import React from 'react';
import { FontIcon, HoverAnimation } from '@gik/ui';
import { IUserProfileClaim, getEndDateTime, getStartDateTime } from '@gik/calendar/models/Claim';
import bemBlock from '@gik/core/utils/bemBlock';
import { openClaimedItemModal } from '@gik/user-profile/components/ClaimedItemModal/ClaimedItemModal';

export interface IClaimedItemCardProps {
  claimedItem: IUserProfileClaim;
}

const blockName = 'claimed-item-card';

export default function ClaimedItemCard({ claimedItem }: IClaimedItemCardProps) {
  const bem = bemBlock(blockName);

  const dateFormat = 'ddd. MMM. D';
  const timeFormat = 'h:mma';

  const getFormattedTime = (): JSX.Element => {
    if (claimedItem.entry.allDay) {
      return <>All day</>;
    } else {
      return (
        <>
          {getStartDateTime(claimedItem).format(timeFormat)}-{getEndDateTime(claimedItem).format(timeFormat)}
        </>
      );
    }
  };

  return (
    <HoverAnimation className={bem('hover-wrapper')}>
      <div
        onClick={e => {
          e.preventDefault();
          openClaimedItemModal({ claimedItem, getFormattedTime, dateFormat });
        }}
        className={bem()}
        id={claimedItem.id.toString()}
      >
        <section className={bem('first-section')}>
          <section className={bem('dates')}>
            <div className={bem('date')}>{getStartDateTime(claimedItem).format(dateFormat)}</div>
            <span className={bem('flex-separator')} />
            <div className={bem('time')}>{getFormattedTime()}</div>
          </section>

          <section className={bem('title-description-container')}>
            <div className={bem('title')}>{claimedItem.entry.typeName}</div>

            <div className={bem('description')}>{claimedItem.entry.title}</div>
          </section>
        </section>

        <section className={bem('info')}>
          <FontIcon name="circle-info-o" />
        </section>
      </div>
    </HoverAnimation>
  );
}
